import * as React from 'react';
const IconCardBackCharPattern = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={226}
    height={204}
    style={{ width: 226, height: 204 }}
    viewBox="0 0 226 204"
    fill="none"
    className="icon-card-back-char-pattern"
    {...props}
  >
    <path
      opacity={0.2}
      d="M45.2722 115.03C45.4519 115.594 45.1848 116.41 45.4289 117.146C52.0039 136.994 68.3674 148.875 86.7323 157.608C97.6347 162.792 109.351 166.836 121.17 169.101C121.967 163.333 125.794 165.782 129.142 168.123C130.603 169.146 136.787 175.848 137.428 177.325C137.677 177.9 137.518 178.28 137.237 178.781L138.274 179.372C138.068 180.124 138.151 181.07 137.87 181.771C136.67 184.801 129.311 189.761 126.306 191.462C124.445 192.513 120.798 194.61 118.953 192.906C117.447 191.517 118.684 188.639 118.309 188.323C113.445 187.296 108.541 186.415 103.76 185.001C91.9929 181.523 75.6281 174.863 65.3976 168.321C63.9662 167.407 62.4008 165.788 61 164.724L60.8025 165.413C59.1781 165.27 59.0504 163.243 58.462 162.839C57.684 162.306 56.9277 163.2 55.9877 161.802C54.736 159.945 55.0878 161.043 53.6741 160.091C52.6729 159.417 50.1261 157.367 49.0997 156.487C47.9489 155.503 47.0196 153.872 45.536 152.999L46.4765 152.751C44.1135 151.854 41.8095 149.322 40.348 147.203C38.4999 144.526 35.9548 141.391 34.0051 138.196C30.6448 132.704 23.8108 119.766 26.7122 113.519C30.6171 105.111 42.513 106.346 45.2842 115.037L45.2722 115.03Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M60.2116 67.5541C60.7045 67.2977 60.5331 66.1755 61.5249 66.0883C66.634 65.6451 66.6775 71.5324 66.4618 74.6994C66.4361 75.0942 66.1159 75.3462 66.8711 75.3538C69.2459 75.3757 73.3543 74.4553 75.8446 74.0322C91.4408 71.3812 106.741 67.909 122.235 64.6741C125.502 65.0041 126.304 68.5081 124.546 70.6103C124.059 71.1911 122.318 71.7145 121.793 72.1067C109.151 81.5173 96.1543 87.8611 81.8217 94.8814C80.8394 95.3627 80.1857 96.2252 78.9415 96.4243L81.6833 99.7414C83.1413 100.985 82.9412 105.24 81.1934 105.591C80.2071 105.788 76.6065 105.435 75.4015 105.264C67.0949 104.111 55.4594 99.8989 47.4961 96.5867C46.7177 96.2607 44.7924 95.4987 44.3644 94.9584C43.6659 94.0719 42.9041 91.8842 43.1507 90.8101C43.4965 89.2935 45.943 85.1429 46.8534 83.5644C48.9475 79.9211 55.4501 69.9206 58.7332 67.7872C59.3631 67.3782 59.9597 67.6808 60.2124 67.5507L60.2116 67.5541Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M116.347 130.497C116.522 131.082 116.723 134.002 116.594 134.615C114.38 145.042 98.3432 142.346 100.306 131.598C101.922 122.748 114.001 122.659 116.349 130.494L116.347 130.497Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M201.906 88.8565C202.29 90.1373 202.734 96.5354 202.451 97.877C197.61 120.717 162.456 114.796 166.746 91.2524C170.279 71.8655 196.755 71.6831 201.909 88.8499L201.906 88.8565Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M150.899 65.0659C150.94 65.2173 151.023 67.8902 150.995 68.2095C150.378 75.4198 140.995 78.1804 136.35 72.6179C129.987 64.9975 140.258 54.2445 148.49 61.2704C148.946 61.6613 150.76 64.5502 150.899 65.0659Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M150.621 139.795C149.99 139.966 147.421 139.661 146.805 139.306C140.707 135.773 146.906 125.993 152.921 131.335C155.428 133.566 153.548 139 150.621 139.795Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M80.039 136.066C79.8911 135.428 80.2895 132.878 80.6679 132.278C84.4253 126.34 93.9863 132.932 88.4209 138.712C86.0977 141.12 80.7278 139.019 80.039 136.066Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M167.918 127.214C167.996 127.503 167.642 129.184 167.476 129.5C166.104 132.139 160.659 130.022 162.916 126.412C164.202 124.358 167.371 125.212 167.915 127.212L167.918 127.214Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M91.9987 153.846C91.7071 153.912 90.0374 153.489 89.7277 153.31C87.1361 151.832 89.453 146.487 92.9841 148.889C94.9926 150.257 94.0219 153.383 92.0006 153.843L91.9987 153.846Z"
      fill="#009DD8"
    />
    <path
      opacity={0.2}
      d="M140.601 96.9163C142.864 106.792 136.514 115.778 126.862 118.144C115.05 121.04 104.29 110.153 106.009 98.3978C108.821 79.1833 136.089 77.249 140.601 96.9163ZM122.478 91.5387C114.425 92.7737 111.254 103.415 117.663 108.478C126.528 115.482 137.52 105.209 132.162 95.995C130.467 93.0793 125.787 91.0324 122.478 91.5387Z"
      fill="#009DD8"
    />
  </svg>
);
export default IconCardBackCharPattern;
